"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = void 0;
const formatString = (mask, reference) => {
    let newReference = mask;
    let ignoreCount = 0;
    for (let n = 0; n < reference.length; n++) {
        if (reference.charAt(n) != mask.charAt(n)) {
            newReference = newReference.replace('X', reference.charAt(n));
            mask.charAt(n) != 'X' && ignoreCount++;
        }
    }
    newReference = newReference.substr(0, reference.length + ignoreCount);
    return newReference;
};
exports.formatString = formatString;
